import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  discoverGiftSets: {
    id: 'pd.availableSets.discoverGiftSets',
    defaultMessage: 'Objevte dárkové sady s tímto produktem.',
  },
  discoverTravelSets: {
    id: 'pd.availableSets.discoverTravelSets',
    defaultMessage: 'Objevte cestovní sady s tímto produktem.',
  },
  discoverEconomySets: {
    id: 'pd.availableSets.discoverEconomySets',
    defaultMessage: 'Objevte výhodná balení s tímto produktem.',
  },
  discoverGiftSetsAndTravelSets: {
    id: 'pd.availableSets.discoverGiftSetsAndTravelSets',
    defaultMessage: 'Objevte dárkové a cestovní sady s tímto produktem.',
  },
  discoverGiftSetsAndEconomySets: {
    id: 'pd.availableSets.discoverGiftSetsAndEconomySets',
    defaultMessage: 'Objevte dárkové sady a výhodná balení s tímto produktem.',
  },
  discoverTravelSetsAndEconomySets: {
    id: 'pd.availableSets.discoverTravelSetsAndEconomySets',
    defaultMessage: 'Objevte cestovní sady a výhodná balení s tímto produktem.',
  },
  discoverSets: {
    id: 'pd.availableSets.discoverSets',
    defaultMessage: 'Objevte sety s tímto produktem. ',
  },
  setsWithThisProduct: {
    id: 'pd.availableSets.setsWithThisProduct',
    defaultMessage: 'Sady s tímto produktem',
  },
});
